import { NotificationSubscription, OrderStatus } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

export const useOrderNotification = () => {
  const { orderStore, requestStore } = useStore();
  const {
    addUnassignedServiceOrder,
    removeCalendarOrder,
    removeUnassignedServiceOrder,
    addOrUpdateCalendarOrder,
    updateOrdersStatus,
  } = orderStore;

  const { addRequest, filterRequestSidePanel } = requestStore;

  useEffect(() => {
    abp.event.on('abp.notifications.received', (userNotification: any) => {
      const notificationName = userNotification.notification.notificationName;
      const result = userNotification.notification.data.properties;

      switch (notificationName) {
        case NotificationSubscription.RequestCreated:
          addRequest(result);
          break;
        case NotificationSubscription.OrderCreated:
          if (
            result.status !== OrderStatus.Approval &&
            result.status !== OrderStatus.Approved
          ) {
            if (result.userId) addOrUpdateCalendarOrder(result);
            else addUnassignedServiceOrder(result);
          }
          filterRequestSidePanel(result.requestId);
          break;
        case NotificationSubscription.OrderUpdated:
          addOrUpdateCalendarOrder(result);
          removeUnassignedServiceOrder(result.id);
          break;
        case NotificationSubscription.OrderDeleted:
          removeCalendarOrder(result.id);
          removeUnassignedServiceOrder(result.id);
          break;
        case NotificationSubscription.OrderUnassigned:
          removeCalendarOrder(result.id);
          addUnassignedServiceOrder(result);
          break;
        case NotificationSubscription.OrdersStatusUpdate:
          updateOrdersStatus(result.orders, result.status);
          break;
        default:
          break;
      }
    });
  }, []);
};
